import React from "react";
import { css } from "@emotion/css";
import { originImage } from "../../assets/images";

const Origin = () => {
    const originStyles = {
        section: css`
            padding: 4rem 0;
            background-color: white;
        `,
        container: css`
            max-width: 80rem;
            margin: 0 auto;
            padding: 0 1rem;
            @media (min-width: 540px) {
                padding: 0 1.5rem;
            }
            @media (min-width: 924px) {
                padding: 0 2rem;
            }
        `,
        title: css`
            text-align: center;
            font-size: 1.5rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 2rem;
            @media (min-width: 768px) {
                font-size: 3rem;
            }
        `,
        mainContainer: css`
            background-color: #f58640;
            border-radius: 1rem;
            padding: 2rem;
            position: relative;
            @media (min-width: 924px) {
                margin-top: 140px;
            }
        `,
        topRow: css`
            display: grid;
            grid-template-columns: 1fr;
            gap: 1.1rem;
            margin-bottom: 2rem;
            @media (min-width: 924px) {
                grid-template-columns: 400px 1fr;
                gap: 20px;
            }
        `,
        imageSection: css`
            display: flex;
            justify-content: left;
            align-items: left;
        `,
        imageContainer: css`
            width: 100%;
            max-width: 400px;

            @media (min-width: 924px) {
                position: absolute;
                top: -125px;
            }
        `,
        originImage: css`
            width: 100%;
            height: auto;
            border-radius: 0.75rem;
            object-fit: cover;
        `,
        badge: css`
            position: absolute;
            bottom: 1rem;
            left: 1rem;
            background-color: #ec4899;
            color: white;
            padding: 0.5rem 1rem;
            border-radius: 9999px;
            font-size: 0.875rem;
            font-weight: 600;
        `,
        rightContent: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
        heading: css`
            color: white;
            font-size: 1.25rem;
            font-weight: 600;
            margin-bottom: 1rem;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        `,
        text: css`
            color: white;
            font-size: 1.1rem;
            line-height: 1.7;
            margin-bottom: 1rem;
        `,
        bottomSection: css`
            grid-column: 1 / -1;
        `,
        bottomText: css`
            color: white;
            font-size: 1.1rem;
            line-height: 1.7;
        `,
        description: css`
            color: #4b5563;
            margin-bottom: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5;

            @media (min-width: 640px) {
                margin-bottom: 1.75rem;
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                margin-bottom: 2rem;
                font-size: 1rem;
            }

            @media (max-width: 768px) {
                text-align: justify;
            }
        `,
    };

    return (
        <section
            className={originStyles.section}
            id="origin"
            aria-labelledby="origin-title"
        >
            <div className={originStyles.container}>
                <h2 className={originStyles.title}>
                    Origin of Club Mango Friends
                </h2>

                <div className={originStyles.mainContainer}>
                    <div className={originStyles.topRow}>
                        <div className={originStyles.imageSection}>
                            <div className={originStyles.imageContainer}>
                                <img
                                    src={originImage}
                                    alt="Friends forming star shape with fingers"
                                    className={originStyles.originImage}
                                />
                            </div>
                        </div>

                        <div className={originStyles.rightContent}>
                            <h3 className={originStyles.heading}>
                                A MAN IS KNOWN BY THE COMPANY HE KEEPS.
                            </h3>
                            <p className={originStyles.text}>
                                Friends and their company are one of the most
                                important elements of life to determine and
                                develop the right qualities within an
                                individual.
                            </p>
                        </div>
                    </div>

                    <div className={originStyles.bottomSection}>
                        <p className={originStyles.bottomText}>
                            The teenage/youth phase of life is highly impacted
                            by the company of friends, as this is the age when
                            we spend most of our time with friends and get
                            influenced by their thoughts, opinions and habits
                            knowingly or unknowingly. Understanding this
                            granular reality, Shreekalp decided to dedicate
                            himself as a good friend and companion guide for
                            youth. He started to teach life values to youth in a
                            way that youth want them, along with a lot of fun
                            and laughter. To make this activity available to a
                            large group of youth, this motto gave birth to the
                            platform of "Club Mango Friends" wherein we can
                            connect with our true friend, "Shreekalp"
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Origin;
